import { render } from "./englishImproveCourseDetail.vue?vue&type=template&id=21312db4&scoped=true"
import script from "./englishImproveCourseDetail.vue?vue&type=script&lang=js"
export * from "./englishImproveCourseDetail.vue?vue&type=script&lang=js"

import "./englishImproveCourseDetail.vue?vue&type=style&index=0&id=21312db4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21312db4"]])

export default __exports__